import { Button, Group } from '@mantine/core';
import { IconDownload, IconTrash } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './SelectionHeaderActions.module.css';

type Props = {
  selectedCount: number;
  onDeleteSelected: () => void;
  onDownloadSelected: () => void;
  onCancel: () => void;
  isDownloading: boolean;
  downloadDisabled?: boolean;
};

export default function SelectionHeaderActions({
  selectedCount,
  onDeleteSelected,
  onDownloadSelected,
  onCancel,
  isDownloading,
  downloadDisabled = false,
}: Props) {
  const hasSelection = selectedCount > 0;

  return (
    <Group gap="xxs" wrap="nowrap">
      <Button
        {...pillProps}
        variant="delete-pill"
        rightSection={<IconTrash size={16} />}
        disabled={!hasSelection}
        onClick={onDeleteSelected}
      >
        Delete selected
      </Button>
      <Button
        {...pillProps}
        variant="download-pill"
        rightSection={<IconDownload size={16} />}
        loading={isDownloading}
        disabled={!hasSelection || downloadDisabled}
        onClick={onDownloadSelected}
      >
        Download selected
      </Button>
      <Button {...pillProps} variant="cancel-pill" onClick={onCancel}>
        Cancel
      </Button>
    </Group>
  );
}

const pillProps = {
  size: 'xs',
  h: 24,
  px: 'xxs',
  fw: FONT_WEIGHTS.semibold,
  classNames: { root: classes.pill, section: classes.section },
} as const;
